export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public apiUrl: string = "";
    public signavioTopK?: number;
    public wellsApiKey: string = "";
    /** Document Finder "Connect folder": Azure Blob container, folder (prefix) and read+list SAS token */
    public azureStorage?: { containerUrl: string; prefix: string; sasToken: string };
}